import blogCarousel from "./blog-carousel";
//Get the number of carousel items to show in carousel for Desktop
function slidePerViewDesktop(element) {
	var setItemToDisplay,
		totalCarousel = element.find(".swiper-slide").length,
		cardCarouselPagination = element.find(".blog-carousel__pagination");
	//Set number of items display in carousel. If there is only two items then set slidesPerView to 2 and so on.
	if (totalCarousel > 3) {
		setItemToDisplay = 3;
		cardCarouselPagination.css('display','flex');
		element.find(".blog-carousel__card").removeClass("mr-0");
		element.find(".blog-carousel__wrapper").removeClass("justify-content-center");
	} else if (totalCarousel == 3) {
		setItemToDisplay = 3;
		cardCarouselPagination.css('display','none');
		element.find(".blog-carousel__wrapper").addClass("three-cards");
	} else if (totalCarousel == 2) {
		setItemToDisplay = 2;
		cardCarouselPagination.css('display','none');
	} else if (totalCarousel == 1) {
		setItemToDisplay = 1;
		cardCarouselPagination.css('display','none');
		element.find(".blog-carousel__wrapper").addClass("one-card");
	}
	if (totalCarousel < 3) {
		element.find(".blog-carousel__wrapper").addClass("justify-content-center");
		element.find(".blog-carousel__card:last-child").addClass("mr-0");
	}
	return setItemToDisplay;
}

//Get the number of carousel items to show in carousel for Tablet
function slidePerViewTablet(element) {

	var setItemToDisplay,
	totalCarousel = element.find(".swiper-slide").length,
	cardCarouselPagination = element.find(".blog-carousel__pagination");
	//Set number of items display in carousel. If there is more than three then set slidesPerView to 2 and so on.
	if (totalCarousel >= 3) {
		setItemToDisplay = 2;
	} else if (totalCarousel == 2) {
		setItemToDisplay = 2;
	} else if (totalCarousel == 1) {
		setItemToDisplay = 1;
	}
	return setItemToDisplay;
}

//Remove Arrow
function removeArrow(element){
	var next = element.children(".blog-carousel__pagination").find(".swiper-button-next"),
	prev = element.children(".blog-carousel__pagination").find(".swiper-button-prev"),
	pagination = element.children(".blog-carousel__pagination");


	if(next.hasClass('swiper-button-disabled') && prev.hasClass('swiper-button-disabled')){
		pagination.hide()
	}else{
		pagination.show();
	}
}

//Init Swiper carousel
function inItSwiper(carouselSlidePerViewDeskotp, carouselSlidePerViewTablet, element,index) {
	var spaceBetweenItems,

	swiperPagination = "."+element.children(".blog-carousel__pagination").find(".swiper-pagination").attr('class'),
	swiperNext = "."+element.children(".blog-carousel__pagination").find(".swiper-button-next").attr('class').split(' ')[0],
	swiperPrev = "."+element.children(".blog-carousel__pagination").find(".swiper-button-prev").attr('class').split(' ')[0];

	//Add space between items if number of of itmes are greater than one
	if (carouselSlidePerViewDeskotp > 1) {
		spaceBetweenItems = 24;
	} else {
		spaceBetweenItems = 0;
	}

	var swiper = new Swiper(element, {
		// slidesPerView: carouselSlidePerViewDeskotp,
		slidesPerView: "auto",
		loop: false,
		centeredSlides: false,
		// slidesPerGroupSkip: 1,
		spaceBetween: spaceBetweenItems,
		navigation: {
			nextEl: swiperNext,
			prevEl: swiperPrev
		},
		on: {
			resize: function(){
				removeArrow(element);
			}
	  }
	});
}

function inItCardCarousel(element, index) {
	var carouselSlidePerViewDeskotp, carouselSlidePerViewTablet;

	//Get number of Carousel items to show on desktop
	carouselSlidePerViewDeskotp = slidePerViewDesktop(element);

	//Get number of Carousel items to show on Tablet
	carouselSlidePerViewTablet = slidePerViewTablet(element);

	//initialize swiper carousel
	inItSwiper(carouselSlidePerViewDeskotp, carouselSlidePerViewTablet,element,index);
}

//Call if card carousel component exist on page
if ($(".blog-carousel__wrapper").length) {
	//Initialize carousel
	$( ".blog-carousel__container").each(function( index ) {
		var element = $(this);
		inItCardCarousel(element,index);
	});
}
